<app-header></app-header>
<div class="content">
<div class="h-100-percent max-width-lg">
    <section class="flex flex-col items-center">
        <img class="mt-20"src="/assets/images/service_unavailable.png">
        <div class="fw-600 fs-24 mt-24"> {{ 'NOTIFICATIONS.SERVICE_UNAVAILBLE' | transloco }} </div>
        <div class="fw-500 fs-16 font-color mt-24"> {{ 'NOTIFICATIONS.SERVICE_UNAVAILABLE_MSG1' | transloco }} </div>
        <div class="fw-500 fs-16 font-color"> {{ 'NOTIFICATIONS.SERVICE_UNAVAILABLE_MSG2' | transloco }} </div>
        <div class="fw-500 fs-16 font-color mt-24 mb-20">Please contact <a class="font-color no-underline cursor-pointer">SaaS_Foundation_Support&#64;temenos.com</a> for support</div>
        <button class="accent ml-16 mb-12" (click)="logout()">{{'MY_ACCOUNT.LOGOUT' | transloco}}</button>
    </section>
    </div>
</div>
<app-footer class="footer"></app-footer> 
  